import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _each from 'lodash/each';
import * as AppActions from '../../actions/AppActions';
import * as FPT from '../../utility/fpt';
import appStore from '../../stores/AppStore';
import { localsMessages } from '../../utility/getTemplateData';
import { Dropdown } from '@paypalcorp/pp-react';
const messages = localsMessages('common/programs');
class Programs extends Component {
  static propTypes = {
    programNames: PropTypes.array,
  };

  componentDidMount() {
    appStore.on('change', this.updateView);
  }

  componentWillUnmount() {
    appStore.removeListener('change', this.updateView);
  }

  updateView = (params) => {
    this.setState({});
  };

  updateSelectedProgram = (event) => {
    AppActions.updateSelectedProgram(event.target.value);
    FPT.trackLinkClickWithData('campaignSelected', {
      campaign: event.target.value,
    });
  };

  getProgramOptions = (programNames) => {
    const options = [{ label: messages.programs.optional, value: '' }];
    _each(programNames, (programName, index) => {
      options.push({
        label: programName,
        value: programName,
      });
    });

    return options;
  };

  render() {
    const { programNames } = this.props;
    const selectedProgram = appStore.getSelectedProgram();

    return (
      <Dropdown
        className="dropdown-wide mt-16 mb-16"
        data-testid="programs-drowpdown"
        value={selectedProgram}
        onChange={this.updateSelectedProgram}
        options={this.getProgramOptions(programNames)}
      />
    );
  }
}
export default Programs;
